import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const MeasurementTypeRepository = RepositoryFactory.get('MeasurementRepository')['MeasurementTypeRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get } = DefaultStoreActions(MeasurementTypeRepository)

export const STORE_MODULE_NAME = 'measurement_type';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
    },
}
